import { Message } from "element-ui";
import Decimal from 'decimal.js';
//正则表达式
const tel = /^1[34578]\d{9}$/;
//函数区
//隐藏中间数字
function hideMidNum(str, frontLen, endLen) {
    if (str) {
        var len = str.length - frontLen - endLen;
        var xing = '';
        for (var i = 0; i < len; i++) {
            xing += '*';
        }
        return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
    } else {
        return ''
    }
}


//精确计算误差的方法   乘法
function accMul(arg1, arg2) {
    if (arg1 == null || arg2 == null) {
        return 0;
    }
    var m = 0,
        s1 = arg1.toString(),
        s2 = arg2.toString();
    try {
        m += s1.split(".")[1].length
    } catch (e) {
    }
    try {
        m += s2.split(".")[1].length
    } catch (e) {
    }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}

//加法
function accAdd(arg1, arg2) {
    if (arg1 == null || arg2 == null) {
        return 0;
    }
    var r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split(".")[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m
}

//减法
function accSub(arg1, arg2) {
    if (arg1 == null || arg2 == null) {
        return 0;
    }
    var r1, r2, m;
    try {
        r1 = arg1.toString().split(".")[1].length
    } catch (e) {
        r1 = 0
    }
    try {
        r2 = arg2.toString().split(".")[1].length
    } catch (e) {
        r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    return (arg1 * m - arg2 * m) / m
}

function xiaoshu(x) {
    var f = parseFloat(x);
    var f = Math.round(x * 100) / 100;
    var s = f.toString();
    var rs = s.indexOf('.');
    if (rs < 0) {
        rs = s.length;
        s += '.';
    }
    while (s.length <= rs + 2) {
        s += '0';
    }
    if (s.indexOf('NaN') != -1) {
        return '';
    } else {
        return s;
    }

}
function stripTrailingZeros (value) {
    if (value === null || value === undefined || value === '') {
        return value;
    }

    try {
        const decimalValue = new Decimal(value);
        if (decimalValue.isNaN()) {
            return value;
        }
        // decimal.js 的 toString() 方法会自动处理去除不必要的尾部零。
        return decimalValue.toString();

    } catch (e) {
        console.error('Error formatting decimal:', e);
        return value; // 发生错误时返回原始值
    }
}
function excelFormatDate(num, format) {
    const time = new Date((num - 1) * 24 * 3600000 + 1)
    time.setYear(time.getFullYear() - 70)
    const year = time.getFullYear() + ''
    const month = time.getMonth() + 1 + ''
    const date = time.getDate() - 1 + ''
    if (format && format.length === 1) {
        return year + format + month + format + date
    }
    return year + (month < 10 ? '0' + month : month) + (date < 10 ? '0' + date : date)
}

function formatDate(time, mark, n) {
    if (!time) {
        return '';
    } else {
        var date = new Date(parseInt(time));
        var dYear = date.getFullYear();
        var dMonth = date.getMonth() + 1;
        var dDate = date.getDate();
        var dHours = date.getHours();
        var dMinutes = date.getMinutes();
        var dSeconds = date.getSeconds();
        if (dMonth < 10) {
            dMonth = '0' + dMonth
        }
        if (dDate < 10) {
            dDate = '0' + dDate
        }
        if (dHours < 10) {
            dHours = '0' + dHours
        }
        if (dMinutes < 10) {
            dMinutes = '0' + dMinutes
        }
        if (dSeconds < 10) {
            dSeconds = '0' + dSeconds
        }
        if (mark) {
            if (n == 3) {
                return dHours + mark + dMinutes + mark + dSeconds;
            } else if (n == 0) {
                return dHours + mark + dMinutes;
            } else if (n == 1) {
                return dYear + mark + dMonth + mark + dDate;
            } else if (n == 2) {
                return dYear + mark + dMonth + mark + dDate + ' ' + dHours + ':' + dMinutes;
            } else {
                return dYear + mark + dMonth + mark + dDate + ' ' + dHours + ':' + dMinutes + ':' + dSeconds;
            }
        } else {
            if (n == 1) {
                return dYear + '-' + dMonth + '-' + dDate;
            } else if (n == 2) {
                return dYear + '-' + dMonth + '-' + dDate + ' ' + dHours + ':' + dMinutes;
            } else {
                return dYear + '-' + dMonth + '-' + dDate + ' ' + dHours + ':' + dMinutes + ':' + dSeconds;
            }
        }
    }
}
function formatMoney(number, decimals, dec_point, thousands_sep) {
    /*
    * 参数说明：
    * number：要格式化的数字
    * decimals：保留几位小数
    * dec_point：小数点符号
    * thousands_sep：千分位符号
    * */
    number = (number + '').replace(/[^0-9+-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            // var k = Math.pow(10, prec);
            // return '' + Math.ceil(n * k) / k;
            return '' + n.toFixed(prec);
        };
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    var re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}
// 日期面板快捷选项
let daterangePickerOptions = {
    shortcuts: [{
        text: '最近一周',
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近一个月',
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近三个月',
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
        }
    }]
}

// input获取焦点时光标调到内容最后
function toInputLast(e) {
    let obj = e.target;
    let objVal = obj.value;
    obj.value = '';
    setTimeout(function () { obj.value = objVal }, 1);
}

function findMenuItem(menuArr, itemCode) {
    return menuArr.reduce((a, item) => {
        if (a) return a;
        if (item.code == itemCode) return item;
        if (item.children) return findMenuItem(item.children, itemCode)
    }, null)
}
// 用户权限
/*
attr: menus || privileges
*/
function rolePrivileges(attr, code) {
    let obj = JSON.parse(sessionStorage.getItem("PRIVILEGES"));
    let flag = false;
    if (obj && obj[attr] && obj[attr].length > 0) {
        obj[attr].forEach(val => {
            if (val.code == code) {
                flag = true;
            };
        });
    };
    return flag;
}

function downloadFile({ url, filename }) {
    if (url) {
        let file = document.createElement('a')
        file.href = url;
        file.download = filename || 'download';
        document.body.appendChild(file);
        file.click();
        document.body.removeChild(file);
    }
}

function downloadBlob(res, { type, filename }, callback) {
	let fileReader = new FileReader();
	fileReader.onload = function() {
	    try{
	        let jsonData = JSON.parse(fileReader.result);  //说明是普通对象数据
	        if (jsonData.code) {
	            Message({ type: 'error', message: jsonData.message });
	            if(callback){
	                callback('error');
	            };
	        };
	    }catch(err){   // 解析成对象失败，说明是正常的文件流
			let blob = new Blob([res], { type: type || "application/vnd.ms-excel" });
			let excel = document.createElement("a");
			excel.style.display = 'none';
			excel.href = URL.createObjectURL(blob);
			excel.download = filename;
			document.body.appendChild(excel);
			excel.click();
			document.body.removeChild(excel);
	        if(callback){
	            callback('success');
	        };
	    }
	};
	fileReader.readAsText(res);
}

//去掉JSON空、null、undefined属性
function removeEmptyFields(obj) {
    let fields = Object.keys(obj);
    fields.forEach(key => {
        let val = obj[key];
        if(val !== null && (!Array.isArray(val)) && typeof val === 'object') {
            removeEmptyFields(val);
        };
        if([undefined,null,''].includes(val)) {
            delete obj[key];
        };
    });
    return obj;
}

// 获取当前日期
function getDateStrForYYYYMMDD(){
    let date = new Date();
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? '0' + m : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    return y + '' + m + '' + d;
}
// 把json改为url参数形式
function jsonToUrlParams(json) {
	let params = [];
	for (let key in json) {
		params.push(`${key}=${json[key] || ''}`);
	}
	return params.join('&');
}

export default {
    tel,
    hideMidNum,
    accMul,
    accAdd,
    accSub,
    xiaoshu,
    excelFormatDate,
    formatDate,
    formatMoney,
    daterangePickerOptions,
    toInputLast,
    findMenuItem,
    rolePrivileges,
    downloadFile,
    downloadBlob,
    removeEmptyFields,
    getDateStrForYYYYMMDD,
    stripTrailingZeros,
	jsonToUrlParams
}

